// ! These values much always match the enum values provided by [SelfServePlan](https://github.com/Humi-HR/application/blob/master/app/Modules/SelfServeOnboarding/Enums/SelfServePlan.php#) in the HR application
export type SelfServePlan = 'hr' | 'hr-timeOff' | 'hr-payroll' | 'hr-payroll-timeOff';

export const SELF_SERVE_TIME_OFF_PLANS: readonly SelfServePlan[] = ['hr-timeOff', 'hr-payroll-timeOff'];

export const SELF_SERVE_PAYROLL_PLANS: readonly SelfServePlan[] = ['hr-payroll', 'hr-payroll-timeOff'];
